import PropTypes from 'prop-types'

import { Col, Row } from "twyne-new.ui";

import AlertLabel from "./AlertLabel";

const propTypes = {
  data: PropTypes.array,
}

export default function Options({ data }) {
  return <Row>
    {data?.map(({ label, value }, idx) => <Col size="3" key={idx}>
      <AlertLabel label={label} value={value} id={idx} />
    </Col>)}
  </Row>
}

Options.propTypes = propTypes
Options.defaultProps = {}
